import qs from 'qs'

export default {
    namespaced: true,
    state: {
        contact_callback_data: {},
    },
    mutations: {
        set_callback_data(state, data) {
            state.contact_callback_data = data;
        }
    },
    actions: {
        async contactUs({commit, state}, data) {
            let parameters = {
                action: 'contactUs',
                data: data,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.data && res.status === 200) {
                    commit("set_callback_data", res.data);
                }
            }).catch((e) => {
                console.log('error')
            })
        }
    },
    getters: {
        get_callback_data: (state) => state.contact_callback_data,
    }
};